const blueFormStyles = theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      width: '100%',
      'font-size': '1.2rem',
    },
  
    cssLabel: {
      color : 'black',  
      'font-size': '1.2rem',   
      "&:focused:not($disabled):not($error)":{
        "color":"black"
      },
      "&.focused": {
        color: "red"
      }
    },
    cssLabelFocused: {
      "color":"black !important",
      "&:focused:not($disabled):not($error)":{
        "color":"black"
      }
    },

    cssLabelError:{
        color: "red !important"
    },
    
    disabled:{},
    error :{},
    focused:{},

    cssOutlinedInput: {
      // '&$cssFocused $notchedOutline': {
      //   borderColor: `${theme.palette.primary.main} !important`,
      // }
    },
  
    cssInput: {
      color: 'black',
      'font-size':'1.2rem'
    },
  
    cssFocused: {},
  
    // notchedOutline: {
    //   borderWidth: '1px',
    //   borderColor: 'green !important'
    // },
    underline: {
          color: theme.palette.common.white,
          borderBottom: theme.palette.common.white,
          '&:after': {
              borderBottom: `2px solid #316E8D`,			
          },				
          '&:focused::after': {
              borderBottom: `2px solid #316E8D`,
          },		
          '&:before': {
              borderBottom: `2px solid #316E8D`,			
          },
          '&:hover:not($disabled):not($focused):not($error):before': {
              borderBottom: '2px solid #316E8D !important',
          },
          '&$disabled:before': {
              borderBottom: `2px dotted #316E8D`,
          },
      },
  })

  export default blueFormStyles;